export const ringcentral_info = 'RingCentral is our organization\'s primary platform for phone calls and voicemail. It\'s accessible from Teams, your desktop, your mobile device, or a web browser.'

export const ringcentral_md = `
# RingCentral
*Last updated on July 14, 2025*

## Overview

RingCentral is our organization's primary platform for phone calls and voicemail. It's accessible from Teams, your desktop, your mobile device, or a web browser—so you can stay connected no matter where you work.

Note: you likely already have a RingCentral account through us. If you're unsure of your login credentials or voicemail password, please contact the IT Help Desk.

## Benefits
- **Accessibility**: RingCentral can be used through your desk phone, Teams, the desktop app, or the mobile app.
- **Friendly Interface**: The RingCentral apps have a simple and easy to learn interface.
- **Voicemail & Call Handling**: Customize call forwarding, listen to voicemails, or read voicemail transcriptions directly from the app.
- **Reliable & Secure**: Enterprise-grade security and strong call quality across all devices.

## Requirements
- Your RingCentral login (usually your work email and the password you created)
- A supported device:
    - Windows computers
    - iOS or Android devices
- RingCentral App (optional but strongly recommended for desktop and mobile)

## Getting Started
1. Download the App:
    - Install the Teams Plugin (recommended): See step 2
    - or download the [Desktop app](ringcentral.com/download)
    - Mobile: Search RingCentral in the App Store or Google Play
2. Install the Teams Plugin
    - Open Teams and click the Apps icon in the left side bar.
    - Search for 'RingCentral' in the search bar.
    - Click on the RingCentral card and click on the Add button.
    - Follow the prompts to get the plugin installed and set up.
    - When you're done, make sure to right click the RingCentral icon in the left side bar and pin it.
2. Log In: 
    - Use your work email address and the password you created.
    - Do not use the express login feature - it is currently not working.
3. Set Up Basics:
    - Record a voicemail greeting (optional)
    - Set your working hours (for call forwarding and presence)

## Support
- Check out [RingCentral's User Guide](https://assets.ringcentral.com/us/guide/ringex_user_guide.pdf)
- Contact our IT Help Desk

`